import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description LoanDocument icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { LoanDocument } from '@sravni/design-system-icons'
 *
 * <LoanDocument />
 * ```
 */
var LoanDocument = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "LoanDocument", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.87 18.4H5.603a1.866 1.866 0 0 1-1.867-1.867V3.466c0-1.031.836-1.866 1.867-1.866H15.87c1.031 0 1.866.835 1.866 1.866v13.067A1.866 1.866 0 0 1 15.87 18.4ZM12.602 5.8h1.866M12.602 8.6h1.866M6.996 12.8h7.467M6.996 15.6h7.467M8.4 5.1v-.7M8.4 9.3v.7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.18 8.8c.182.296.492.501.866.501H8.813a.983.983 0 0 0 .24-1.936L7.74 7.036A.984.984 0 0 1 7.979 5.1H8.746c.373 0 .682.204.863.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { LoanDocument };
//# sourceMappingURL=LoanDocument.js.map
